import {collection, component, EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";
import {MembershipTypeReferenceData} from "../membership-type/membership-type.data";
import {UncachedImageData} from "../../shared/image/uncached-image.data";
import {MixAndMatchReferenceData} from "../../pricing/mix-and-match/mix-and-match.data";
import {DiscountReferenceData} from "../../pricing/discount/discount.data";
import {EntitlementProductData} from "../../pricing/entitlement/entitlement.data";

export enum LoyaltyCardProductSelection {
    SELLABLE = <any>"SELLABLE",
    CATEGORY = <any>"CATEGORY",
    CUSTOM_GROUP = <any>"CUSTOM_GROUP"
}

export enum LoyaltyCardType {
    STAMPS = <any>"Stamps",
    POINTS = <any>"Points"
}

export enum LoyaltyCardPeriodUnit {
    DAYS = <any>"Day(s)",
    WEEKS = <any>"Weeks(s)",
    MONTHS = <any>"Month(s)"
}

export class LoyaltyCardPropertiesData extends EntityData<LoyaltyCardPropertiesData> {
    @field categoryId: number;
    @field sellableId: number;
    @field customObjectId: number;
    @field numberTimes: number;
    @field testingPeriod: number;
    @field testingPeriodUnit: LoyaltyCardPeriodUnit = LoyaltyCardPeriodUnit.DAYS;
    @field excludeSubCategory: boolean = false;
    @field soldAsProductLine: boolean = true;
    @field soldWithinCompositeProduct: boolean = true;
    @field soldAsExtraIncludeDefault: boolean = false;
    @field soldAsExtraExcludeDefault: boolean = false;
}

export class LoyaltyCardRewardData extends EntityData<LoyaltyCardRewardData> {
    @field actionId: number;
    @field marketingCampaignId: number;
    @field marketingCampaignName: string;
    @field entitlementTemplateId: number;
    @field usageLimit: number = 1;
    @field daysToExpire: number = 365;
    @component mixAndMatch: MixAndMatchReferenceData;
    @component discount: DiscountReferenceData;
    @collection(EntitlementProductData) products: EntitlementProductData[];
    @component image: UncachedImageData;
    @field imageAutoCrop: boolean = false;
    @field appText1: string;
    @field appText2: string;
    @field showTitleOnDealCard: string;
    @field featureOnAppMenu: boolean = true;
    @field showAppQrCode: boolean = false;
    @field showActionButtonOnDealCard: boolean = true;
    @field orderAhead: boolean = true;
    @field orderDelivery: boolean = true;
    @field orderAtTable: boolean = true;
}

export class LoyaltyCardData extends EntityData<LoyaltyCardData> {
    @identifier id: number;
    @field name: string;
    @field cardType: LoyaltyCardType = LoyaltyCardType.STAMPS;
    @field cardAvailable: boolean = true;
    @field cardGroup: string;
    @field currentCard: boolean = true;

    @collection(MembershipTypeReferenceData) membershipTypes: MembershipTypeReferenceData[];

    @component properties: LoyaltyCardPropertiesData;
    @field discountedItems: boolean = false;
    @field freeItems: boolean = false;

    @field appCardName: string;
    @field appCardThemeName: string;
    @field appItemDescription: string;
    @field appGoalDescription: string;
    @field showEmpty: boolean = false;
    @field pointsRequiredToDisplay: number;
    @field pointsRequiredToRedeem: number;
    @component image: UncachedImageData;

    @component reward: LoyaltyCardRewardData;

    @transientField productSelection: LoyaltyCardProductSelection = LoyaltyCardProductSelection.CATEGORY;

    override onLoad(): void {
        this.productSelection = this.properties.sellableId ? LoyaltyCardProductSelection.SELLABLE
            : this.properties.customObjectId ? LoyaltyCardProductSelection.CUSTOM_GROUP
                : LoyaltyCardProductSelection.CATEGORY;
    }
}
